import React from "react";
import {
  Box,
  Avatar,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { ITutorialJourneyProfileDto } from "@growth-machine-llc/stridist-api-client";

export interface ProfileSelectProps {
  value: number | null;
  profiles: ITutorialJourneyProfileDto[];
  onChange: (profileId: number | null) => void;
  mb?: number;
  label?: string;
}

export const ProfileSelect: React.FC<ProfileSelectProps> = ({
  value,
  profiles,
  onChange,
  mb = 2,
  label = "Profile",
}) => {
  const selected = profiles.find((p) => p.id === value) || null;

  return (
    <FormControl fullWidth sx={{ mb }}>
      <InputLabel id="profile-select-label" shrink>
        {label}
      </InputLabel>
      <Select
        labelId="profile-select-label"
        value={value ?? ""}
        label={label}
        onChange={(e) =>
          onChange(e.target.value ? Number(e.target.value) : null)
        }
        displayEmpty
        notched
        renderValue={() =>
          selected ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar src={selected.avatar || ""} sx={{ width: 24, height: 24 }} />
              <span>{selected.name}</span>
            </Box>
          ) : (
            <em>Without profile</em>
          )
        }
        sx={{
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            gap: 1,
          },
        }}
      >
        <MenuItem value="">
          <em>Without profile</em>
        </MenuItem>
        {profiles.map((p) => (
          <MenuItem key={p.id} value={p.id}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar src={p.avatar || ""} sx={{ width: 24, height: 24 }} />
              {p.name}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
